<template>
  <div>
    <b-modal v-model="isComponentAjoutClient"
      has-modal-card
      width="960px"
      class="modal"
      @close="nomClient=''">
      <app-creation-client
        :nouveauDevisCommande="nouveauDevisCommande"
        :nomClient="nomClient"
        :typeAjoutClientComplet="typeAjoutClientComplet"/>
    </b-modal>

    <b-table
      :data="isEmpty ? [] : nouveauDevisCommande.intervenants"
      :bordered="isBordered"
      :striped="isStriped">
      <b-table-column
              cellClass="is-vcentered"
              field="adressePostale"
              v-slot="props"
              :label="$i18n.t('ajoutDevis.table.customer')">
        <span v-if="props.row.nomCommercial">
          <p class="label is-marginless">{{ props.row.titre }}
            <b-tooltip :label="$t('ajoutDevis.clients.clientExonerationTva')"
                       v-if="props.row.annonceur && func.getExonerationTva(props.row)"
                       type="is-warning"
                       position="is-right">
            <b-icon icon="earth-arrow-right" class="is-cursor-pointer" size="is-small"
                    type="is-warning">
            </b-icon>
            </b-tooltip>
            <b-tooltip :label="$t('ajoutDevis.clients.prospect')"
                       v-if="props.row.tiers && props.row.tiers.prospect"
                       type="is-warning"
                       position="is-right">
            <b-icon icon="account-search" class="is-cursor-pointer" size="is-small"
                    type="is-warning">
            </b-icon>
            </b-tooltip>
          </p>
          <router-link-blank
            :to="{ name: 'c.bodac.clients/contacts-client', params: { id: props.row.tiersId }}"
            class="lien"
            :message="props.row.nomCommercial">
          </router-link-blank>
        </span>
        <b-autocomplete
          v-else
          v-model="nomClient"
          :open-on-focus="openOnFocus"
          :data="dataClients"
          field="nomCommercialAvecVille"
          @select="client => ajouterIntervenant(client)"
          @input="getAsyncClientData"
          :loading="isFetching"
          :placeholder="$t('ajoutDevis.clients.searchClient')">
          <template slot="header">
            <a @click="checkPermissions(permTiers.maj) ? isComponentAjoutClient=true : showPopUp()">
              <a class="lien"
              :class="{ 'text-access-no-permission' : !checkPermissions(permTiers.maj)}">
                <span> {{ $t('ajoutDevis.actions.addClient') }}</span>
              </a>
            </a>
            <br>
            <a
              @click="checkPermissions(permTiers.maj) ? isAdvancedSearch = true : showPopUp()"
              :class="{ 'text-access-no-permission' : !checkPermissions(permTiers.maj) }"
              class="lien is-inline-block pdt-10px">
              {{ $t('ajoutDevis.actions.advancedSearch') }}
            </a>
          </template>
          <template slot-scope="props">
            {{ props.option.nomCommercialAvecVille }}
            <span
              v-if="props.option.blocageLevel === levelComptant
                || props.option.blocageLevel === levelTotal">
              &nbsp;-&nbsp;
            </span>
            <span class="has-text-warning has-text-weight-bold"
              v-if="props.option.blocageLevel === levelComptant">
              {{ levelToString(props.option.blocageLevel) }}
            </span>
            <span class="has-text-danger has-text-weight-bold"
              v-if="props.option.blocageLevel === levelTotal">
              {{ levelToString(props.option.blocageLevel) }}
            </span>
          </template>
        </b-autocomplete>
      </b-table-column>
      <b-table-column
            cellClass="is-vcentered"
            width="300"
            field="contact"
            v-slot="{ row }"
            :label="$i18n.t('ajoutDevis.table.contact')">
        <div v-if="row.nomCommercial">
          <multi-contact-intervenant
              v-if="isMultiContact"
              :isEdit="true"
              :intervenant="row"/>
          <b-field v-else
            :type="isContactArchived(row.contactId) ? 'is-warning' : ''"
            :message="isContactArchived(row.contactId) ?
            $t('detailContact.warning.archivedContactSelectedAbove') : ''">
            <b-select v-model="row.contactId"
              @input="handleContactChangeOnCreation(row.contactId)" expanded>
              <option></option>
              <option v-for="contact in contacts(row)"
                      :key="contact.id"
                      :value="contact.id">
                <span v-if="contact.fonction">
                  {{contact.fonction}} -
                </span>
                <span> {{contact.nom}} {{contact.prenom}} </span>
              </option>
            </b-select>
          </b-field>
        </div>
      </b-table-column>
      <b-table-column
            cellClass="is-vcentered"
            field="adressePostale"
            v-slot="props"
            :label="$t('ajoutDevis.table.address')">
        <div v-if="props.row.nomCommercial">
          {{props.row.adressePostale.adresse1}}
          <span v-if="props.row.adressePostale.adresse2">
            <br/>{{props.row.adressePostale.adresse2}}
          </span>
          <span v-if="props.row.adressePostale.adresse3">
            <br/>{{props.row.adressePostale.adresse3}}
          </span>
          <br/>
          <span v-if="props.row.adressePostale.ville">
            {{props.row.adressePostale.codePostal}} - {{props.row.adressePostale.ville}}
          </span>
        </div>
      </b-table-column>
      <b-table-column
            cellClass="is-vcentered"
            field="last_name"
            v-slot="props"
            width="200"
            :label="$t('ajoutDevis.table.percentageOfBilling')"
            class="is-paddingless">
        <b-field v-if="props.row.nomCommercial" class="columns is-marginless">
          <input-currency v-model="props.row.repartition"
              class="input-border-none no-border-radius-right column is-paddingless"
              isNumber="true">
          </input-currency>
          <b-select v-model="props.row.typeRepartition"
            class="input-border-none column is-narrow is-paddingless">
            <option v-for="saisie in listeSaisiesFacturation"
                    :key="saisie.code"
                    :value="saisie.code">
              {{$t(saisie.libelle)}}
            </option>
          </b-select>
        </b-field>
      </b-table-column>
      <b-table-column
        cellClass="is-vcentered has-text-centered"
        width="160"
        :label="$t('ajoutDevis.table.settlement')"
        v-slot="props">
        <div class="columns is-vcentered is-marginless">
          <qd-button
            v-if="props.row.nomCommercial"
            class="is-primary column pdv-0"
            @click="actionPopUpReglement(props.row)"
            :icon-left="isRowReglement(props.row) ? 'magnify' : 'plus-circle'">
              {{ isRowReglement(props.row)
                ? $t('ajoutDevis.actions.show') : $t('ajoutDevis.actions.add') }}
          </qd-button>
          <b-tooltip
            class="column"
            v-if="props.row.nomCommercial &&
            (!!props.row.delaiReglementId ^ !!props.row.modeReglementId)"
            :label="!props.row.delaiReglementId ?
              $t('ajoutDevis.informations.dontHaveSettlementPeriod') :
              $t('ajoutDevis.informations.dontHaveSettlementMode')"
            multiline
            type="is-warning"
            position="is-top">
            <b-icon
              icon="alert-outline"
              type="is-warning">
            </b-icon>
          </b-tooltip>
        </div>
      </b-table-column>
      <b-table-column
        headerClass="pdh-0"
        cellClass="is-vcentered has-check-centered"
        width="60"
        centered>
          <template slot="header">
            <b-tooltip :label="$t('ajoutDevis.table.advertiser')" centered>
              <span> {{ $t('ajoutDevis.table.advertiserInitiale') }}</span>
            </b-tooltip>
          </template>
          <template slot-scope="props">
            <qd-checkbox
              v-if="props.row.nomCommercial"
              id="checkboxAnnonceur"
              @input="defineTitreIntervenant(props.row)"
              v-model="props.row.annonceur">
            </qd-checkbox>
          </template>
      </b-table-column>
      <b-table-column
        headerClass="pdh-0"
        cellClass="is-vcentered has-check-centered"
        width="60"
        centered>
        <template slot="header">
          <b-tooltip :label="$t('ajoutDevis.table.mandatary')" centered>
            <span> {{ $t('ajoutDevis.table.mandataryInitiale') }}</span>
          </b-tooltip>
        </template>
        <template slot-scope="props">
            <qd-checkbox
            v-if="props.row.nomCommercial"
            id="checkboxMandataire"
            @input="defineTitreIntervenant(props.row)"
            v-model="props.row.mandataire">
          </qd-checkbox>
        </template>
      </b-table-column>
      <b-table-column
        headerClass="pdh-0"
        width="60"
        cellClass="is-vcentered has-check-centered"
        centered>
          <template slot="header">
            <b-tooltip :label="$t('ajoutDevis.table.originator')" centered>
              <span> {{ $t('ajoutDevis.table.originatorInitiale') }}</span>
            </b-tooltip>
          </template>
          <template slot-scope="props">
            <qd-checkbox
              v-if="props.row.nomCommercial"
              id="checkboxDonneurOrdre"
              @input="defineTitreIntervenant(props.row)"
              v-model="props.row.donneurOrdre">
            </qd-checkbox>
          </template>
      </b-table-column>
      <b-table-column
        headerClass="pdh-0"
        width="60"
        cellClass="is-vcentered has-check-centered"
        centered>
        <template slot="header">
          <b-tooltip :label="$t('ajoutDevis.table.payer')" centered>
            <span> {{ $t('ajoutDevis.table.payerInitiale') }}</span>
          </b-tooltip>
        </template>
        <template slot-scope="props">
          <qd-checkbox
            :disabled="intervenantDansEcheancier(props.row.tiersId) && gestionEcheancier"
            v-if="props.row.nomCommercial"
            id="checkboxPayeur"
            @input="defineTitreIntervenant(props.row)"
            v-model="props.row.payeur"
            @click.native="checkPayeur(props.row.tiersId)">
          </qd-checkbox>
          <niveau-blocage-icone
            v-if="props.row.tiers && props.row.tiers.blocageLevel"
            :niveau="props.row.tiers.blocageLevel"
            :description="props.row.tiers.descriptionBlocage"/>
        </template>
      </b-table-column>
      <b-table-column
        headerClass="pdh-0"
        width="60"
        cellClass="is-vcentered has-check-centered"
        centered>
        <template slot="header">
          <b-tooltip :label="$t('ajoutDevis.table.newCustomer')" centered>
              <span> {{ $t('ajoutDevis.table.newCustomerInitiale') }}</span>
          </b-tooltip>
        </template>
        <template slot-scope="props">
          <qd-checkbox v-if="props.row.nomCommercial"
            class="centrer-checkbox"
            v-model="props.row.nvClient">
          </qd-checkbox>
        </template>
      </b-table-column>
      <b-table-column
        headerClass="pdh-0"
        width="60"
        cellClass="is-vcentered has-check-centered"
        v-slot="props"
        custom-key="edit"
        centered>
        <div v-if="props.row.nomCommercial">
          <a class="centrer-checkbox" @click="editionIntervenant(props.row)">
            <b-icon
              icon="pencil-box-outline"
              :type="props.row.titre? 'is-success' : 'is-primary'">
            </b-icon>
          </a>
        </div>
      </b-table-column>
      <b-table-column
        headerClass="pdh-0"
        width="60"
        cellClass="is-vcentered has-check-centered"
        custom-key="delete"
        v-slot="props"
        centered>
        <div v-if="props.row.nomCommercial">
          <a class="centrer-checkbox" @click="supprimerIntervenant(props.row)">
            <b-icon
              icon="delete-forever"
              type="is-danger">
            </b-icon>
          </a>
        </div>
      </b-table-column>
    </b-table>
    <b-modal v-model="isComponentReglement"
             has-modal-card
             class="modal"
             width="450px">
      <app-reglement :etat="etatReglementConsulter" :intervenant="intervenant"
                      @enregistrer="miseAJourIntervenant"/>
    </b-modal>
    <b-modal v-model="popUpEditIntervenant" has-modal-card class="modal" width="960px">
        <popUpEditionIntervenant :intervenant="intervenantToEdit"
                                 @updateInt="updateInt"
        :isDevis="nouveauDevisCommande.type === typeDevis"></popUpEditionIntervenant>
    </b-modal>
    <b-modal v-model="popUpEditContacts">
      <popUpEditContacts :intervenant="intervenantToEdit" />
    </b-modal>
    <b-modal
      v-model="isAdvancedSearch"
      class="modal"
      width="1400px"
      has-modal-card>
      <popUpAdvencedSearch
        @addClient="client => ajouterIntervenant(client)"
        @removeClient="client => supprimerIntervenant(client)"
        :selections="nouveauDevisCommande.intervenants"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import inputCurrency from '@/components/general/inputCurrency';
import { getAllByTradeName } from '@/api/tiers/index';
import creerIntervenant from '@/services/devisCommandes/creerIntervenant';
import miseAJourListeIntervenants from '@/services/devisCommandes/miseAJourListeIntervenants';
import addIntervenant from '@/services/devisCommandes/addIntervenant';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import * as devisConf from '@/configuration/devisConf';
import { TIERS } from '@/configuration/permissionsBodacConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import popUpEditionIntervenant from '@/components/devisCommandes/popUpEditionIntervenant';
import { toggleTarifUnitaire } from '@/services/devisCommandes/ligneCommande/gestionTarifUnitaire';
import updateModeCalculHonoraireLigneCommandeHonoraire from '@/services/ligneCommande/updateModeCalculHonoraire';
import defineTitreIntervenant from '@/services/devisCommandes/defineTitreIntervenant';
import {
  LIMITE_AU_PAIEMENT_COMPTANT,
  TOTAL,
} from '@/configuration/tiers/levelBlocage';
import multiContactIntervenant from '@/components/devisCommandeFacture/multicontact/multiContactIntervenant';
import levelString from '@/services/tiers/levelToString';
import messageInformation from '@/services/general/messageInformation';
import {
  TIERS_TYPE_CLIENT,
  TIERS_SOUS_TYPE_AUCUN,
  TYPOLOGIE_AUCUN,
  LISTE_TYPOLOGIE,
} from '@/configuration/tiers/tiersConf';
import popUpEditContacts from '@/components/devisCommandes/editionDevisCommande/p_editContacts';
import getExonerationTva from '@/services/tiers/getExonerationTva';
import popUpAdvencedSearch from '@/components/devisCommandes/editionDevisCommande/p_advancedSearch';
import niveauBlocageIcone from '@/components/general/NiveauBlocageIcone';
import Reglement from './reglement';
import CreationClient from './creationClient';

const Clients = createNamespacedHelpers('clients');
const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');

export default {
  name: 'selection-client',
  props: {
    nouveauDevisCommande: {
      type: Object,
    },
    gestionEcheancier: {
      type: Boolean,
      required: false,
      default: true,
    },
    typeAjoutClientComplet: {
      type: String,
      default: '',
    },
    isMultiContact: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    appCreationClient: CreationClient,
    inputCurrency,
    appReglement: Reglement,
    routerLinkBlank,
    popUpEditionIntervenant,
    popUpEditContacts,
    popUpAdvencedSearch,
    multiContactIntervenant,
    niveauBlocageIcone,
  },
  data() {
    return {
      isEmpty: false,
      isBordered: true,
      isStriped: true,
      isComponentReglement: false,
      nomClient: null,
      keepFirst: false,
      openOnFocus: false,
      selected: null,
      isComponentAjoutClient: false,
      dataClients: [],
      isFetching: false,
      intervenant: null,
      etatReglementConsulter: null,
      listeSaisiesFacturation: devisConf.INTERVENANT_REPARTITION_TYPE,
      permTiers: TIERS,
      intervenantToEdit: null,
      typeDevis: devisConf.TYPE_DEVIS,
      popUpEditIntervenant: false,
      levelComptant: LIMITE_AU_PAIEMENT_COMPTANT,
      levelTotal: TOTAL,
      popUpEditContacts: false,
      isAdvancedSearch: false,
      func: { getExonerationTva },
    };
  },
  computed: {
    ...Clients.mapGetters({
      clients: 'clients',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    filteredDataObj() {
      return this.clients.filter((option) => {
        return option.nomCommercial;
      });
    },
    allMonoContacts() {
      return this.nouveauDevisCommande.intervenants
        .filter(i => i.tiersId)
        .flatMap((intervenant) => {
          return intervenant.tiers.contacts;
        });
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    contacts(intervenant) {
      const retour = this.allMonoContacts.filter(contact => !contact.archive);
      if (!retour.some(contact => contact.id === intervenant.contactId)) {
        const find = this.allMonoContacts.find(c => c.id === intervenant.contactId);
        if (find) retour.push(find);
      }
      return retour;
    },
    handleContactChangeOnCreation(contactId) {
      if (!contactId) return;
      if (this.nouveauDevisCommande.id) return;
      const contact = this.allMonoContacts.find((contact) => {
        return contact.id === contactId;
      });
      if (contact) {
        this.nouveauDevisCommande.intervenants.forEach((intervenant) => {
          if (intervenant.tiersId === contact.tiersId) {
            intervenant.contact = contact;
            intervenant.contactId = contact.id;
          }
          return intervenant;
        });
      }
    },
    isContactArchived(contactId) {
      return this.allMonoContacts.some((contact) => {
        return contact?.id === contactId && contact?.archive;
      });
    },
    updateInt() {
      let intFind = this.nouveauDevisCommande.intervenants.find((int) => {
        return int.tiersId === this.intervenantToEdit.tiersId;
      });
      if (intFind) intFind = this.intervenantToEdit;
    },
    roleIsIntoSociete(roleIntervenant) {
      return this.societeActive.roles.some((role) => {
        return role === roleIntervenant;
      });
    },
    async defineTitreIntervenant(intervenant) {
      defineTitreIntervenant(intervenant, this.$i18n);

      if (!intervenant.role && intervenant.tiers && intervenant.tiers.role) {
        intervenant.role = intervenant.tiers.role;
      }

      if (intervenant.role && intervenant.payeur && this.roleIsIntoSociete(intervenant.role)) {
        this.nouveauDevisCommande.role = intervenant.role;
      }
      await updateModeCalculHonoraireLigneCommandeHonoraire(
        this.nouveauDevisCommande.lignesCommande,
        this.nouveauDevisCommande.intervenants,
      );

      if (this.nouveauDevisCommande.lignesCommande) {
        this.nouveauDevisCommande.lignesCommande.forEach((ligne) => {
          toggleTarifUnitaire(ligne);
        });
      }
      this.$emit('calcul');
    },
    checkPayeur(tiersId) {
      if (this.intervenantDansEcheancier(tiersId) && this.gestionEcheancier) {
        this.$emit('deleteOrDeselectPayeurInEcheancier', false);
        return;
      }
      if (!this.gestionEcheancier && this.nouveauDevisCommande.type === devisConf.TYPE_DEVIS) {
        this.$emit('regenereEcheancier');
      }
    },
    editionIntervenant(intervenant) {
      this.intervenantToEdit = intervenant;
      this.popUpEditIntervenant = true;
    },
    isRowReglement(row) {
      return !!(row.modeReglementId || row.delaiReglementId);
    },
    actionPopUpReglement(row) {
      this.intervenant = row;
      this.etatReglementConsulter = this.isRowReglement(row);
      this.isComponentReglement = true;
    },
    async supprimerIntervenant(props) {
      if (this.intervenantDansEcheancier(props.tiersId) && this.gestionEcheancier) {
        this.$emit('deleteOrDeselectPayeurInEcheancier', true);
        return;
      }
      if (!this.gestionEcheancier && this.nouveauDevisCommande.type === devisConf.TYPE_DEVIS) {
        this.$emit('regenereEcheancier');
      }
      this.nouveauDevisCommande.intervenants.splice(
        this.nouveauDevisCommande.intervenants.indexOf(props),
        1,
      );

      if (this.nouveauDevisCommande.lignesCommande) {
        await updateModeCalculHonoraireLigneCommandeHonoraire(
          this.nouveauDevisCommande.lignesCommande,
          this.nouveauDevisCommande.intervenants,
        );
        this.nouveauDevisCommande.lignesCommande.forEach((ligne) => {
          toggleTarifUnitaire(ligne);
        });
      }

      this.$emit('calcul');
      this.dataClients = [];
    },
    async ajouterIntervenant(intervenant) {
      if (!intervenant || intervenant === undefined) {
        return;
      }
      if (this.nouveauDevisCommande !== undefined
        && this.nouveauDevisCommande.type === devisConf.TYPE_COMMANDE
        && intervenant.blocageLevel === this.levelTotal) {
        messageInformation(this.$i18n.t('detailClient.popupBlocage.unselectable',
          { nomCommercial: intervenant.nomCommercial }), 'is-danger');
        return;
      }
      this.nomClient = null;
      addIntervenant(this.nouveauDevisCommande, creerIntervenant(intervenant));
      await updateModeCalculHonoraireLigneCommandeHonoraire(
        this.nouveauDevisCommande.lignesCommande,
        this.nouveauDevisCommande.intervenants,
      );
      this.dataClients = [];
    },
    miseAJourIntervenant(value) {
      this.nouveauDevisCommande.intervenants = miseAJourListeIntervenants(
        value,
        this.nouveauDevisCommande.intervenants,
      );
    },
    getAsyncClientData: debounce(function ClientData() {
      this.dataClients = [];
      this.isFetching = true;
      getAllByTradeName(this.nomClient, this.societeActiveId,
        TIERS_TYPE_CLIENT, [TIERS_SOUS_TYPE_AUCUN]).then((response) => {
        response.data.result.items.forEach((client) => {
          if (client.prospect && this.nouveauDevisCommande.type === devisConf.TYPE_COMMANDE) return;
          if (!client.archive && !this.nouveauDevisCommande.intervenants.find((el) => {
            return el.tiersId === client.id;
          })) {
            client.nomCommercialAvecVille = client.code + ' - ' + client.nomCommercial;
            const typologie = LISTE_TYPOLOGIE.find((typo) => typo.code === client.typologie);
            if (typologie.code !== TYPOLOGIE_AUCUN) {
              client.nomCommercialAvecVille += ` (${this.$t(typologie.libelle)})`;
            }
            if (client.adressePostale && client.adressePostale.ville) {
              client.nomCommercialAvecVille += ' - ' + adressFullStringGetter(client.adressePostale, false);
            }
            if (client.compteComptable) {
              client.nomCommercialAvecVille += ' - ' + client.compteComptable;
            }
            this.dataClients.push(client);
          }
        });
        this.isFetching = false;
      }).catch(() => {
        this.isFetching = false;
      });
    }, 500),
    intervenantDansEcheancier(tiersId) {
      if (!this.nouveauDevisCommande.echeanciers) return false;
      let isInEcheancier = false;
      this.nouveauDevisCommande.echeanciers.forEach((echeancier) => {
        if (echeancier.quantitePeriodicite === 0) return;
        echeancier.echeancierLignes.forEach((ligne) => {
          if (ligne.tiersId === tiersId) isInEcheancier = true;
        });
      });
      return isInEcheancier;
    },
    levelToString(blocageLevel) {
      return levelString(this.$i18n, blocageLevel);
    },
  },
};
</script>

<style>
</style>
